export default {
    name: 'Official server',

    apiUrl: window.CONFIG.API_URL,
    websocketUrl: window.CONFIG.WEBSOCKET_URL,
    prefix: '',

    settings: {
        official: true,
        host: 'screeps.com',
        port: '',
        password: ''
    },

    users: null
} as IServer;
